<template>

    <section class="publication">
        <div class="container">

            <div class="row">
                <div class="col-md-12">

                    <div class="publication__heading d-flex">
                        <publication-progress :step-info="{ info: currentStepComponent.progress, count: initial.length }" />
                        <h2 v-if="currentStepComponent">{{$store.getters.t(currentStepComponent.title)}}</h2>
                        <span v-if="currentStepComponent.subtitle" class="publication__subtitle">{{$store.getters.t(currentStepComponent.subtitle)}}</span>
                        <button v-if="!currentStepComponent.required" type="button" class="btn publication__btn"
                                @click.prevent="handleTransform('increment')"
                        >{{$store.getters.t('common_skip')}}</button>
                    </div>

                </div>
            </div>

            <div class="publication__content">
                <div v-show="rerender" class="publication__content-placeholder"></div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="publication__slider" ref="slider" :style="{maxHeight: `${sliderHeight}px`}" >

                            <div class="publication__slider-track clearfix"
                                 :style="{width: `${trackWidth}px`, transform: `translateX(${trackTransform}px)`,
                                 transition: rerender ? 'none' : 'transform 0.4s ease'}">

                                <template v-if="initial.length">

                                    <template v-for="(s, idx) in initial">

                                        <div class="publication__slider-slide" ref="slides" :style="{width: `${slideWidth}px`}" :key="idx">
                                            <component :server="{...server, idx, createdTarget: createdId}" @parent-update="stepUpdate" ref="stepRefs" :is="s.component.name"></component>
                                        </div>

                                    </template>

                                </template>

                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="row" v-if="step < initial.length - 1">
                <div class="col-md-12">
                    <div class="publication__nav d-flex">
                        <button type="button" class="btn publication__btn" v-if="step >= 1"
                                @click.prevent="handleTransform('decrement')"
                        >{{$store.getters.t('common_back')}}</button>
                        <button type="button" class="btn publication__btn publication__btn--primary"
                                @click.prevent="handleTransform('increment')" v-if="step < initial.length - 2"
                        >{{$store.getters.t('common_forward')}}</button>
                        <button type="button" class="btn publication__btn publication__btn--primary" :disabled="disableActionButton"
                                @click.prevent="submitForm" v-if="currentStepComponent.component.name === 'PublicationEdit'"
                        >
                            {{
                                (currentStepComponent.valid && !disableActionButton  && $store.getters.t('publication_submit_save_and_moderate')) ||
                                (disableActionButton && $store.getters.t('publication_submit_wait_check')) ||
                                $store.getters.t('publication_submit_fix_errors_retry')
                            }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </section>

</template>

<script>

import {paginationScrollTo} from '../../helpers/helpers';

import createPersonal from "./createPersonal";
import editPersonal from "./editPersonal";

import SliderMixin from '../mixins/SliderMixin';
import StateMixin from "../mixins/StateMixin";

import PublicationProgress from "../PublicationProgress";

import SelectLocation from "../Personal/SelectLocation";
import PersonalCategories from "./PersonalCategories";
import PersonalProfile from "./PersonalProfile";
import PublicationPreview from "./PublicationPreview";
import PublicationPreviewAvatar from "./PublicationPreviewAvatar";
import PublicationSliderGallery from "./PublicationSliderGallery";
import PersonalFilters from "./PersonalFilters";
import PublicationEdit from "./PublicationEdit";
import PublicationSuccess from "./PublicationSuccess";

export default {
    name: "index",
    props: ['server'],
    mixins: [SliderMixin, StateMixin],
    provide() {
        return {
            step: () => this.step
        };
    },
    components: {
        PublicationProgress, SelectLocation, PersonalCategories, PersonalProfile,
        PublicationPreview, PublicationPreviewAvatar, PublicationSliderGallery,
        PersonalFilters, PublicationEdit, PublicationSuccess
    },
    data(){

        return{
            slides: createPersonal,
            rerender: false,
            merge_model: false,
            createdId: null,
            STORE_ENDPOINT:  this.server.model ? `/pets/${this.server.model.id}/update` : '/pets/store',

        }

    },

    created(){
        this.CREATE_STATE_BY_KEY('personal');
        if (
            this.server.model
            && Object.keys(this.server.model).length
            && window.location.pathname.search(/\/personal_pet\/\d+$/g)
        ) {

            this.merge_model = true;

            const prepareState = {

                not_moderated_fields: this.server.model['not_moderated_fields'].concat([
                    'selectedCity', 'avatarPath', 'previewImages', 'petAvatar',
                    'not_moderated_fields'
                ]),

                images: [],

                petAvatar: `/storage${this.server.model.avatar.path}`,
                avatarPath: `/storage${this.server.model.avatar.path}`,

                previewImages: this.server.model['images'].map( photo => {
                    return {
                        id: photo.id,
                        base64: '/storage' + photo.path,
                        name: (
                            (arr) => { return arr[ arr.length - 1 ] }
                        )(photo.path.split('/')),
                    }
                } ),

                selectedCity: { ...this.server.model.city },

            };


            Object.keys(this.GET_STATE).forEach( _k => {

                if ( ! this.server.model.hasOwnProperty( _k ) || prepareState.hasOwnProperty( _k ) ) return;

                prepareState[ _k ] = this.server.model[ _k ];

            });

            this.slides = editPersonal;

            this.SET_STATE_BY_MODEL( prepareState )

        }

    },

    methods: {

        async submitForm(){

            this.disableActionButton = true;

            const valid = this.$refs.stepRefs[ this.step ].isValid()

            if ( ! valid ) {
                this.handleSliderHeight();
                this.disableActionButton = false;
            }

            if ( valid ){

                const success = await this.ACTION_STORE( this.STORE_ENDPOINT )

                if( success.success ) {

                    this.createdId = success.data.id;

                    new Promise(res => {

                        paginationScrollTo('.publication__heading');
                        setTimeout(() => {
                            res();
                        }, 700)

                    }).then( () => {
                        this.handleTransform( 'increment' )
                        return this.slides[ this.step ].valid = success;
                    } )


                } else {
                    this.disableActionButton = false;

                    if (result && result.errors) {
                        for (let key in result.errors) {
                            var message = result.errors[key];
                            if (key.startsWith('images.') && message == 'The ' + key + ' failed to upload.') {
                                alert(this.$store.getters.t('publication_image_too_large_5mb'));
                            }
                            if(key == 'avatar' && message == ('The ' + key + ' failed to upload.')) {
                                alert(this.$store.getters.t('publication_avatar_too_large_5mb'));
                            }
                        }
                    }
                }


            }

        }

    }


}
</script>

<style scoped>

</style>
